/* Varianty sekce Funkce. Fail-open: bez JS je v A přejížděcí pás, v B všechny detaily, v C posouvatelný pás. */
(function () {
  var hladce = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  /* A: záložky a přejížděcí pódium se drží v synchronu */
  document.querySelectorAll('[data-fa]').forEach(function (box) {
    var lista = box.querySelector('.fa-tabs');
    var pas = box.querySelector('.fa-track');
    var tabs = [].slice.call(box.querySelectorAll('.fa-tab'));
    var panely = [].slice.call(box.querySelectorAll('.fa-p'));
    var akt = 0;
    function oznac(i) {
      if (i === akt && tabs[i].getAttribute('aria-selected') === 'true') return;
      akt = i;
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
      });
      if (lista.scrollWidth > lista.clientWidth) {
        var t = tabs[i];
        lista.scrollTo({ left: t.offsetLeft - (lista.clientWidth - t.offsetWidth) / 2, behavior: hladce });
      }
    }
    function jdi(i, fokus) {
      i = (i + tabs.length) % tabs.length;
      oznac(i);
      pas.scrollTo({ left: panely[i].offsetLeft - pas.offsetLeft, behavior: hladce });
      if (fokus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { jdi(i); });
      t.addEventListener('keydown', function (e) {
        var k = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (k) { e.preventDefault(); jdi(i + k, true); }
      });
    });
    var cekam = 0;
    pas.addEventListener('scroll', function () {
      if (cekam) return;
      cekam = requestAnimationFrame(function () {
        cekam = 0;
        oznac(Math.round(pas.scrollLeft / (pas.clientWidth || 1)));
      });
    }, { passive: true });
  });

  /* B: detail stojí pod řadou s dlaždicí, řadu počítá CSS mřížka */
  document.querySelectorAll('[data-fb]').forEach(function (box) {
    var dlazdice = [].slice.call(box.querySelectorAll('.fb-t'));
    var detaily = dlazdice.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    function rozloz() {
      var sl = getComputedStyle(box).gridTemplateColumns.split(' ').length || 1;
      dlazdice.forEach(function (t, i) {
        t.style.order = i * 10;
        detaily[i].style.order = (Math.floor(i / sl) + 1) * sl * 10 - 5;
      });
    }
    function otevri(i, posun) {
      dlazdice.forEach(function (t, k) {
        var j = k === i;
        t.setAttribute('aria-expanded', j ? 'true' : 'false');
        detaily[k].hidden = !j;
      });
      if (posun && i >= 0) detaily[i].scrollIntoView({ block: 'nearest', behavior: hladce });
    }
    dlazdice.forEach(function (t, i) {
      t.addEventListener('click', function () {
        otevri(t.getAttribute('aria-expanded') === 'true' ? -1 : i, true);
      });
    });
    rozloz();
    otevri(window.matchMedia('(min-width:768px)').matches ? 0 : -1, false);
    window.addEventListener('resize', rozloz);
  });

  /* C: posun pásu je čas, pozadí jde z rána přes poledne do noci */
  var STOPY = [[0, [255, 243, 196]], [0.35, [255, 212, 59]], [0.62, [191, 224, 255]], [0.82, [51, 163, 255]], [1, [19, 44, 72]]];
  function barva(p) {
    for (var i = 1; i < STOPY.length; i++) {
      if (p <= STOPY[i][0]) {
        var a = STOPY[i - 1], b = STOPY[i], t = (p - a[0]) / (b[0] - a[0]);
        return 'rgb(' + a[1].map(function (v, k) { return Math.round(v + (b[1][k] - v) * t); }).join(',') + ')';
      }
    }
    return 'rgb(19,44,72)';
  }
  document.querySelectorAll('[data-fc]').forEach(function (box) {
    var pas = box.querySelector('.fc-pas');
    var sipky = [].slice.call(box.querySelectorAll('.fc-s'));
    var cekam = 0;
    function krok() {
      var k = box.querySelectorAll('.fc-k');
      return k[1].offsetLeft - k[0].offsetLeft;
    }
    function obnov() {
      var max = pas.scrollWidth - pas.clientWidth;
      var p = max > 0 ? Math.min(1, pas.scrollLeft / max) : 0;
      var sek = box.closest('.fc-sek');
      if (sek) {
        sek.style.setProperty('--fc-bg', barva(p));
        sek.style.setProperty('--fc-tx', p > 0.82 ? '#fff' : '#1A4886');
      }
      box.style.setProperty('--fc-bg', barva(p));
      box.style.setProperty('--fc-p', p.toFixed(4));
      var noc = p > 0.82;
      box.style.setProperty('--fc-tx', noc ? '#fff' : '#1A4886');
      box.classList.toggle('is-noc', noc);
      sipky[0].disabled = pas.scrollLeft < 4;
      sipky[1].disabled = pas.scrollLeft > max - 4;
    }
    pas.addEventListener('scroll', function () {
      if (cekam) return;
      cekam = requestAnimationFrame(function () { cekam = 0; obnov(); });
    }, { passive: true });
    sipky.forEach(function (s) {
      s.addEventListener('click', function () {
        pas.scrollBy({ left: krok() * +s.getAttribute('data-smer'), behavior: hladce });
      });
    });
    window.addEventListener('resize', obnov);
    obnov();

    /* Telefon: svislá osa, otevřená je vždy jedna funkce. Bez JS jsou otevřené všechny */
    var karty = [].slice.call(box.querySelectorAll('.fc-k'));
    function nastav(k, otevrit) {
      k.classList.toggle('is-open', otevrit);
      k.querySelector('.fc-tg').setAttribute('aria-expanded', otevrit ? 'true' : 'false');
    }
    karty.forEach(function (k, i) {
      nastav(k, i === 0);
      k.addEventListener('click', function () {
        if (!window.matchMedia('(max-width:767px)').matches) return;
        var pred = k.getBoundingClientRect().top;
        var otevrit = !k.classList.contains('is-open');
        karty.forEach(function (x) { nastav(x, x === k && otevrit); });
        var posun = k.getBoundingClientRect().top - pred;
        if (posun) window.scrollBy({ top: posun, behavior: 'instant' });
      });
    });
  });
})();
